import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import PortingCNAM from '../../containers/Provisioning/Porting/PortingCNAM';

const EditCnam = ({ isOpen, onConfirm, onCancel, }) => {
    const number = useSelector(state => state.AppState.numbers.numberByID)
    // if (!number.number) return "Loading..."
    return (
        <Modal size="lg" style={{ maxWidth: '900px' }} isOpen={isOpen}>
            <ModalHeader>
                Order Port In (Update Features)
            </ModalHeader>
            <ModalBody>
                <PortingCNAM onStepBack={onCancel} onStepNext={onConfirm} features={number.features} numbers={[number.number]} />
            </ModalBody>
        </Modal>
    );
};

export default EditCnam
